/**
 * CSP nonce bootstrap — MUST be the first webpack entry.
 *
 * Sets webpack's internal __webpack_nonce__ runtime variable (mapped to
 * __webpack_require__.nc) from the value the server injected into the HTML.
 * style-loader reads __webpack_require__.nc when it creates <style> tags,
 * so this must run before any CSS import is evaluated.
 */

// eslint-disable-next-line no-undef
__webpack_nonce__ = window.__webpack_nonce__;
